module.exports = __webpack_public_path__ + "img/热线系统有字.e3cdb3fe.png";